import Blog from "@/Layouts/Blog";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";
import { Link, animateScroll as scroll } from "react-scroll";

export default function Blogs({ blogs }) {
    return (
        <Blog>
            <Head>
                <title>Blogs</title>
                <link rel="canonical" href={route("blogs.index")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Een overzicht van alle informatieve blogs die je kunnen helpen bij het sporten. Van informatie over voeding tot het verschil in diverse trainingsmethode's."
                />
                <meta
                    property="og:description"
                    content="Een overzicht van alle informatieve blogs die je kunnen helpen bij het sporten. Van informatie over voeding tot het verschil in diverse trainingsmethode's."
                />
                <meta property="og:url" content={route("blogs.index")} />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Blog overzicht - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                {/* <Hero>
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline  xs:text-3xl sm:text-3xl md:text-7xl lg:text-7xl">
                        Blogs
                    </h1>
                    <div className="text-center pt-16">
                        <Link
                            to="blogs"
                            smooth={true}
                            offset={0}
                            duration={500}
                            className="mt-12 uppercase md:ml-4 inline-flex items-center justify-center cursor-pointer px-6 py-3 border border-transparent text-base font-semibold rounded-md shadow-sm text-white bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                        >
                            Bekijk blogs
                        </Link>
                    </div>
                </Hero> */}

                <div
                    className="xs:py-6 sm:py-6 md:py-12 lg:py-12 xs:px-8 sm:px-8 md:px-16 lg:px-16"
                    id="blogs"
                >
                    <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                        {blogs.map((post) => (
                            <div
                                key={post.title}
                                className="flex flex-col rounded-lg shadow-lg overflow-hidden"
                            >
                                <div className="flex-shrink-0">
                                    <a href={post.href}>
                                        <picture>
                                            <source
                                                srcSet={post.src_webp}
                                                type="image/webp"
                                                className="min-w-full"
                                            />
                                            <source
                                                srcSet={post.src}
                                                type="image/jpeg"
                                                className="min-w-full"
                                            />
                                            <img
                                                src={post.src}
                                                className="min-w-full"
                                            />
                                        </picture>
                                    </a>
                                </div>
                                <div className="flex-1 bg-gray-900 p-6 flex flex-col justify-between">
                                    <div className="flex-1">
                                        <p className="text-sm font-medium text-we-are-purple">
                                            <a
                                                href={post.href}
                                                className="hover:underline"
                                            >
                                                {post.name}
                                            </a>
                                        </p>
                                        <div
                                            href={post.href}
                                            className="block mt-2"
                                        >
                                            <a
                                                href={post.href}
                                                className="text-xl font-semibold text-gray-100"
                                            >
                                                {post.title}
                                            </a>
                                            <p className="mt-3 text-base text-gray-100">
                                                {post.description}
                                            </p>
                                            <a
                                                href={post.href}
                                                className="inline-flex items-center justify-center cursor-pointer py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-we-are-yellow "
                                            >
                                                Lees meer
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <Contact />
            </div>
        </Blog>
    );
}
